import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={14}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={1.625}
      y={1}
      width={12.75}
      height={9}
      stroke="white"
      strokeOpacity={0.85}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M4.58725 6.46967C4.29436 6.76257 4.29436 7.23744 4.58725 7.53033C4.88015 7.82322 5.35502 7.82322 5.64791 7.53033L4.58725 6.46967ZM11.1243 4.93456C11.4334 4.65875 11.4603 4.18464 11.1845 3.87561C10.9087 3.56657 10.4346 3.53963 10.1255 3.81544L11.1243 4.93456ZM7.15345 4.96412L7.68378 4.43379C7.54313 4.29314 7.35236 4.21412 7.15345 4.21412C6.95454 4.21412 6.76377 4.29314 6.62312 4.43379L7.15345 4.96412ZM8.47928 6.28995L7.94895 6.82028C8.23016 7.10149 8.68197 7.11431 8.97868 6.84951L8.47928 6.28995ZM5.64791 7.53033L7.68378 5.49445L6.62312 4.43379L4.58725 6.46967L5.64791 7.53033ZM6.62312 5.49445L7.94895 6.82028L9.00961 5.75962L7.68378 4.43379L6.62312 5.49445ZM8.97868 6.84951L11.1243 4.93456L10.1255 3.81544L7.97989 5.73039L8.97868 6.84951Z"
      fill="white"
      fillOpacity={0.85}
    />
    <line
      x1={3.875}
      y1={13}
      x2={12.125}
      y2={13}
      stroke="white"
      strokeOpacity={0.85}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default SVGComponent;
